import styled from 'styled-components';
// import Test1Icon from '@/assets/mo/Test1.svg?react';
// import Test2Icon from '@/assets/mo/Test2.svg?react';
// import Test3Icon from '@/assets/mo/Test3.svg?react';
import { kakaoLogin } from '@/api/auth';
import { useAuthStore } from '@/store/useAuthStore';
// import { useNavigate } from 'react-router-dom';

const SideDrawer = ({ onClose }: { onClose: () => void }) => {
  const user = useAuthStore((state) => state.user);
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  // const navigate = useNavigate();

  const handleKakaoLogin = async () => {
    try {
      const { url } = await kakaoLogin(); // ✅ 받은 URL 추출
      console.log('✅ 카카오 로그인 URL:', url);

      window.location.href = url; // ✅ 카카오 로그인 페이지로 이동
    } catch (error) {
      console.error('❌ 로그인 오류:', error);
    }
  };

  const handleLogout = () => {
    useAuthStore.getState().logout();
    localStorage.removeItem('auth-storage'); // ✅ persist key까지 제거
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    onClose(); // 드로어 닫기
    window.location.href = '/'; // 필요 시 홈으로 이동
  };

  return (
    <>
      <OverlayWrapper>
        <DimmedBackground onClick={onClose} />
        <DrawerWrapper>
          {isLoggedIn && user ? (
            <ProfileSection>
              <ProfileInner>
                <UserName>{user.username}님</UserName>
                <UserGreeting>안녕하세요, 올받음입니다</UserGreeting>
              </ProfileInner>
            </ProfileSection>
          ) : (
            <LoginPromptSection onClick={handleKakaoLogin}>
              <LoginTextWrapper>
                <LoginTitle>로그인 / 회원가입</LoginTitle>
                <LoginDesc>조금 더 빠르게 진행이 가능해요</LoginDesc>
              </LoginTextWrapper>
            </LoginPromptSection>
          )}

          {/* <QuickMenuSection>
          <QuickMenuInner>
            <QuickItem>
              <StyledTest1Icon />
              <QuickLabel>내 정보</QuickLabel>
            </QuickItem>
            <QuickItem>
              <StyledTest2Icon />
              <QuickLabel>선임 현황</QuickLabel>
            </QuickItem>
            <QuickItem>
              <StyledTest3Icon />
              <QuickLabel>내가 쓴 후기</QuickLabel>
            </QuickItem>
          </QuickMenuInner>
        </QuickMenuSection> */}

          <MenuSpacer>
            <MenuList>
              <MenuItem>
                <MenuInner>
                  <MenuText onClick={() => (window.location.href = '/appointment')}>
                    손사선임
                  </MenuText>
                </MenuInner>
              </MenuItem>
              <MenuItem>
                <MenuInner>
                  <MenuText
                    onClick={() => (window.location.href = 'https://nicetomeetyou.oopy.io/')}
                  >
                    전화상담
                  </MenuText>
                </MenuInner>
              </MenuItem>
              <MenuItem>
                <MenuInner>
                  <MenuText
                    onClick={() => (window.location.href = 'https://www.hiadjuster.com/review')}
                  >
                    후기
                  </MenuText>
                </MenuInner>
              </MenuItem>
            </MenuList>

            <NoticeWrapper>
              <NoticeText>이용안내</NoticeText>
            </NoticeWrapper>

            <MenuList>
              <MenuItem>
                <MenuInner>
                  <MenuText onClick={() => (window.location.href = '/intro/news')}>
                    최신소식
                  </MenuText>
                </MenuInner>
              </MenuItem>
              <MenuItem>
                <MenuInner>
                  <MenuText onClick={() => (window.location.href = '/intro/faq')}>
                    자주 묻는 질문
                  </MenuText>
                </MenuInner>
              </MenuItem>
              <MenuItem>
                <MenuInner>
                  <MenuText onClick={() => (window.location.href = '/intro/adjusters')}>
                    손사 소개
                  </MenuText>
                </MenuInner>
              </MenuItem>
              <MenuItem>
                <MenuInner>
                  <MenuText onClick={() => (window.location.href = '/intro/about')}>
                    올받음 소개
                  </MenuText>
                </MenuInner>
              </MenuItem>
            </MenuList>
          </MenuSpacer>
          {isLoggedIn && user && <LogoutButton onClick={handleLogout}>로그아웃</LogoutButton>}
        </DrawerWrapper>
      </OverlayWrapper>
    </>
  );
};

export default SideDrawer;

const OverlayWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000; /* ✅ header보다 확실히 위에 */
  width: 100vw;
  height: 100vh;
  pointer-events: none; /* 전체 클릭 방지 기본값 */

  & > * {
    pointer-events: auto; /* 내부 요소만 클릭 가능하게 */
  }
`;

const DrawerWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 75vw; // ✅ 변경
  height: auto;
  min-height: 100vh;
  flex-direction: column;
  align-items: flex-start;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.15);
  transform: translateX(-100%);
  animation: slideIn 0.3s ease-out forwards;

  @keyframes slideIn {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0%);
    }
  }
`;

const MenuList = styled.div`
  display: flex;
  width: 100%;
  max-width: 75vw; // ✅ 변경
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

const ProfileSection = styled.div`
  display: flex;
  padding: 26.5px 92.285px 26.5px 15.715px;
  align-items: center;
  background: #fff;
`;

const ProfileInner = styled.div`
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

const UserName = styled.div`
  align-self: stretch;
  color: var(--gray-ui_gray01, #191919);
  font-size: 22px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.44px;
  text-align: start;
`;

const UserGreeting = styled.div`
  color: var(--gray-ui_gray04, #6f6f6f);
  font-size: 12px;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.24px;
`;

const MenuSpacer = styled.div`
  flex: 1 0 0;
  align-self: stretch;
  background: #fff;
`;

const MenuItem = styled.div`
  display: flex;
  height: 44px;
  padding: 4px 16px;
  align-items: center;
  align-self: stretch;
`;

const MenuInner = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;
  align-self: stretch;
  border-bottom: 1px solid var(--Primary-lightgray, #f3f3f3);
`;

const MenuText = styled.div`
  color: var(--gray-ui_gray03, #3a3a3a);
  font-size: 12px;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.24px;
`;

const NoticeText = styled.div`
  color: var(--gray-ui_gray04, #6f6f6f);
  text-align: start;
  font-size: 10px;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.2px;
  text-align: start;
`;

const DimmedBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5); // ✅ 반투명한 검정 배경
  z-index: 999; // ✅ 드로어보다 하나 낮은 z-index

  pointer-events: auto;
`;

// const StyledTest1Icon = styled(Test1Icon)`
//   width: 45px;
//   height: 45px;
// `;

// const StyledTest2Icon = styled(Test2Icon)`
//   width: 45px;
//   height: 45px;
// `;

// const StyledTest3Icon = styled(Test3Icon)`
//   width: 45px;
//   height: 45px;
// `;

const NoticeWrapper = styled.div`
  width: 100%;
  padding: 16px;
  background: #fff;
  min-height: 56px;
  display: flex;
  align-items: flex-end;
`;

const LoginPromptSection = styled.div`
  display: flex;
  padding: 32px clamp(16px, 5vw, 92.285px) 32px 16px;
  align-items: center;
  align-self: stretch;
  background: #fff;
  cursor: pointer;
`;

const LoginTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
`;

const LoginTitle = styled.div`
  align-self: stretch;
  color: var(--gray-ui_gray01, #191919);
  font-size: 16px;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.32px;
  text-align: start;
`;

const LoginDesc = styled.div`
  color: var(--gray-ui_gray04, #6f6f6f);
  font-size: 12px;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.24px;
`;

const LogoutButton = styled.button`
  width: 100%;
  padding: 14px 16px;
  background: #fff;
  color: #ff4d4f; /* 🔴 빨간색 */
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-top: 1px solid var(--Primary-lightgray, #f3f3f3);
  cursor: pointer;
  text-align: left;

  &:hover {
    background: #fff0f0;
    color: #d9363e;
  }
`;
